import { Inject, Injectable } from '@angular/core';
import { ɵInjectableAnimationEngine } from '@angular/platform-browser/animations';
import { DwEventService, DwOrmDataService, DwOrmDataServiceToken, DwQueryHelper } from '@devwareapps/devware-cap';
import { NotesMetaDataItemNames, NotesMetaDataService, NotesNoteParentEntity, NotesNoteEntity } from '../meta-data/notes-meta-data.service';
import * as moment_ from 'moment';
import { filter, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { NoteEntity } from '../../../meta-data/app-meta-data.service';
import { NoteRefreshEventData } from '../note-control-new/models/note-refresh-event-data.model';
import { NoteReadOnlyEventData } from '../note-control-new/models/note-readonly-event-data.model';
const moment = moment_;

@Injectable()
export class NotesRepositoryService {

    NOTES_TOPIC = 'NOTES_REFRESH';
    NOTES_READONLY = 'NOTES_READONLY';

    constructor(@Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
        private dwEventService: DwEventService, 
    ) {
    }

    loadNotes(noteParentId: number, filterOnNoteType: boolean = false, noteTypeId?: number): Observable<NotesNoteEntity[]> {
        const md = new NotesMetaDataService();
        const qh = new DwQueryHelper();

        const query = this.buildNotesBaseQuery()
                            .AddFilterAnd(qh.filters.Equal(md.NotesNote.IsDeleted, false))
                            .AddFilterAnd(qh.filters.Equal(md.NotesNote.NoteParentId, noteParentId))
                            .AddPrefetchPath(md.NotesNote.Relations.NoteType);
                            //results[0].NoteType.MetaDataLookupId

        if (filterOnNoteType) {
            query.AddFilterAnd(qh.filters.Equal(md.NotesNote.NoteTypeId, noteTypeId));
        }

        return this.dataService.executeQuery(query);
    }

    createNote(comment: string, noteParentId: number, noteTypeId: number, accessoryData?: number): Observable<NotesNoteEntity> {
        const note: NotesNoteEntity = {
            _itemName: NotesMetaDataItemNames.NotesNote,
            NoteParentId: noteParentId,
            NoteTypeId: noteTypeId,
            Note: comment,
            AccessoryData: accessoryData
        }

        // use query to reload item so it loads the display values
        var loadItemQuery = this.buildNotesBaseQuery();

        return this.dataService.saveEntity(note, false, loadItemQuery);
    }
    updateNote(note : NotesNoteEntity): Observable<NotesNoteEntity> {
        var loadItemQuery = this.buildNotesBaseQuery();
        return this.dataService.saveEntity(note, false, loadItemQuery);
    }

    createNoteParent(): Observable<number> {

        // build note parent entity
        const noteParent: NotesNoteParentEntity = {
            _itemName: NotesMetaDataItemNames.NotesNoteParent,
            CreatedDateTime: moment().format('MM/DD/YYYY hh:mm A')
        }

        // Save note parent and return note parent id
        return this.dataService.saveEntity(noteParent).pipe(map((savedNoteParent: NotesNoteParentEntity) => {
            return savedNoteParent.NoteParentId;
        }));
    }

    deleteNote(noteId: number): Observable<any> {
        const note: NoteEntity = {
            _itemName: NotesMetaDataItemNames.NotesNote,
            NoteId: noteId,
            IsDeleted: true
        };

        return this.dataService.saveEntity(note);
    }

    saveDataWithNoteParentId(itemName: string, keyName: string, keyValue: number, noteKey: string, noteParentId: number) {
        // Save the parent entity
        var parentItem = this.dataService.createDummyEntity(itemName);

        parentItem[keyName] = keyValue;

        parentItem[noteKey] = noteParentId;

        this.dataService.saveEntity(parentItem)
            .subscribe(savedparent => {
                // Not really anything to do here
            });
    }

    private buildNotesBaseQuery() {
        const md = new NotesMetaDataService();
        const qh = new DwQueryHelper();

        var query = md.NotesNote.CreateQuery();

        query.AddPrefetchPath(md.NotesNote.Relations.EthosUserByCreatedByEthosUserId);
        query.AddPrefetchPath(md.NotesNote.Relations.EthosUserByModifiedByEthosUserId);

        query.FieldSettings.LoadAllLookupDisplayFields = true;

        query.OrderBy(md.NotesNote.CreatedByDateTime, false);

        return query;
    }


    public publishNoteRefreshEvent(noteTypeId?: number) {

        const eventData: NoteRefreshEventData = {
            noteTypeId : noteTypeId
        };

        this.dwEventService.publishEvent(this.NOTES_TOPIC, eventData);
    }
    public publishNoteReadOnlyEvent(key?: string, readOnly?: boolean) {
        const eventData: NoteReadOnlyEventData = { key : key, readOnly : readOnly };
        this.dwEventService.publishEvent(this.NOTES_READONLY, eventData);
    }

    public getNoteRefreshEvent(noteTypeId?: number): Observable<NoteRefreshEventData> {
        return this.dwEventService.getEventData<NoteRefreshEventData>(this.NOTES_TOPIC)
            .pipe(filter(noteData => {
                if (noteTypeId && noteTypeId != noteData.noteTypeId) {
                    return false;
                }
                return true;
            }))
    }
    public getNoteReadOnlyEvent(key?: string): Observable<NoteReadOnlyEventData> {
        return this.dwEventService.getEventData<NoteReadOnlyEventData>(this.NOTES_READONLY)
                    .pipe(filter(noteData => noteData.key == key));
}


}

export interface EditableNote extends NotesNoteEntity {
    CreatedByEthosEthosUser : any,
    ModifiedByEthosEthosUser : any
}

